import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PropTypes from "prop-types";
import Loader from "../components/loader";

const AppRoute = ({ component: Component, path, exact, ...rest }) => {
  return (
    <Routes>
      <Route
        path={path}
        exact={exact}
        element={
          <Suspense fallback={<Loader />}>
            <Component {...rest} />
          </Suspense>
        }
      />
    </Routes>
  );
};

AppRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  path: PropTypes.string.isRequired,
  exact: PropTypes.bool,
};

AppRoute.defaultProps = {
  exact: false,
};

export default AppRoute;
